import { jsx as _jsx } from "react/jsx-runtime";
import { TabsContentsRoot } from './TabsContents.styled';
import { useTabContents } from './TabsContents.hooks';
// Component.
// -----------------------------------------------------------------------------
export const TabsContents = ({ definitions, mode, type }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { tab } = useTabContents(definitions);
    // Render.
    // ---------------------------------------------------------------------------
    return tab ? (_jsx(TabsContentsRoot, { mode: mode, type: type, children: tab.content })) : null;
};
//# sourceMappingURL=TabsContents.js.map